import type { Config } from 'react-player';

export const MIN_VOLUME = 0;
export const MAX_VOLUME = 1;

export const CONFIG: Config = {
  youtube: {
    playerVars: { showinfo: 1 }
  },
  facebook: {
    appId: '229138694600829',
    version: 'v3.3',
    playerId: ''
  },
  file: {
    forceVideo: true
  }
};
